import React from "react";

function ProductoLista({ productosPorFamilia, categoria }) {
    return Object.keys(productosPorFamilia).map((familia) => (
        <div key={familia} className="mb-4 mt-8 lg:px-7">
            <div className="border-b border-[#84a5ac] mb-4">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 text-[#df5f4c] font-dancing-script"
                    style={{
                        textShadow: '2px 0 #1e3b5b, -2px 0 #1e3b5b, 0 2px #1e3b5b, 0 -2px #1e3b5b, 2px 2px #1e3b5b, -2px -2px #1e3b5b, -2px 2px #1e3b5b, 2px -2px #1e3b5b',
                    }}
                >
                    {familia}
                </h2>
            </div>
            <div className="grid grid-cols-2 gap-3 text-[#f4b215]">
                {productosPorFamilia[familia].map((producto) => (
                    <div key={producto.id} className="flex flex-col border-b-[1px]  border-[#84a5ac] ">
                        <div className="flex justify-between items-center">
                            <p
                                className="text-[10px] sm:text-[13px] md:text-md font-semibold truncate font-montserrat text-[#f4b215] stroke-blue"

                            >
                                {producto.nombre}
                            </p>

                            <p className="text-xs md:text-md font-semibold bg-[#1e3b5b] px-[1px]  rounded relative max-w-[100px] overflow-hidden font-montserrat text-[#f4edda]"
                            >${producto.precio}</p>
                        </div>
                        <p className="text-xs  sm:text-[10px] md:text-xs text-[#1e3b5b] mb-1 md:mb-2 font-montserrat">{producto.descripcion}</p>
                    </div>

                ))}
            </div>
        </div>
    ));
}

export default ProductoLista;
